// extracted by mini-css-extract-plugin
export var actionButton = "_p0-0";
export var actionMenuContainer = "_p0-i";
export var bubble = "_p0-2";
export var bubbleActionMenu = "_p0-j";
export var bubbleContext = "_p0-6";
export var bubbleItems = "_p0-7";
export var customer = "_p0-3";
export var divider = "_p0-8";
export var fileList = "_p0-9";
export var hiddenComment = "_p0-o";
export var infoAbove = "_p0-a";
export var internal = "_p0-4";
export var lightActionButton = "_p0-1";
export var link = "_p0-b";
export var merchant = "_p0-5";
export var message = "_p0-c";
export var profilePicture = "_p0-e";
export var quillToolbarContainer = "_p0-f";
export var senderDate = "_p0-g";
export var senderDateCustomer = "_p0-h";
export var senderName = "_p0-d";
export var time = "_p0-k";
export var uploadedImage = "_p0-l";
export var username = "_p0-m";
export var xsmall = "_p0-n";